/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Pxk_Item_Debt_BadgeInputs */

const vi_orders_pxk_item_debt_badge = /** @type {(inputs: Orders_Pxk_Item_Debt_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nợ lô`)
};

/**

* @param {Orders_Pxk_Item_Debt_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const orders_pxk_item_debt_badge = /** @type {((inputs?: Orders_Pxk_Item_Debt_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pxk_Item_Debt_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_orders_pxk_item_debt_badge(inputs)
});